var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-introduction"},[_c('img',{staticClass:"projectIntroductionImg",attrs:{"src":require("@/assets/projectIntroductionImg.png"),"alt":""}})])
}]

export { render, staticRenderFns }